import { usePage } from '@inertiajs/react'
import type { SharedProps, Entitlement, BooleanEntitlement, IntegerEntitlement } from '@/types/shared'

export function useEntitlement(key: string): Entitlement | undefined {
  const { entitlements } = usePage<SharedProps>().props
  return entitlements[key]
}

export function useBooleanEntitlement(key: string): { enabled: boolean } {
  const entitlement = useEntitlement(key) as BooleanEntitlement | undefined
  return { enabled: entitlement?.enabled ?? false }
}

export function useIntegerEntitlement(key: string): {
  limit: number
  unlimited: boolean
  used: number
  canCreate: boolean
  remaining: number
} {
  const entitlement = useEntitlement(key) as IntegerEntitlement | undefined
  const limit = entitlement?.limit ?? 0
  const unlimited = entitlement?.unlimited ?? false
  const used = entitlement?.used ?? 0
  const canCreate = unlimited || used < limit
  const remaining = unlimited ? Infinity : Math.max(0, limit - used)

  return { limit, unlimited, used, canCreate, remaining }
}

export function useEntitlements() {
  const { entitlements } = usePage<SharedProps>().props
  return entitlements
}
